// extracted by mini-css-extract-plugin
export default {"root":"CIOP9mS9","head":"N7vD8ka6","title":"PuojfLnR","description":"I5TieuFO","middle":"xiXx6BQc","trailing":"RroSsiiV"};